import React from "react";
import useQueryURL from "../../../../../common/hooks/useQueryURL";
import TuleButton from "../../../../../common/components/atom/TuleButton.tsx/TuleButton";

import useNavigationApp from "../../../../../navigation/useNavigationApp";
import { useAuth } from "../../../../auth/hooks";
import { userRoles } from "../../../../user/types/user.types";

export default function AddNewCreateUserLinkButtonPresenter({
  modalId,
  goToMode,
}: {
  modalId?: string;
  goToMode?: boolean;
}) {
  const { setQueryValue } = useQueryURL();
  const MODAL_ID_PARAMS = modalId || "modal_add_user_link";
  const navigation = useNavigationApp();
  const { userRole } = useAuth();
  if (!userRole || userRole < userRoles.ADMIN) {
    return <></>;
  }
  const onClick = () => {
    if (goToMode) {
      navigation.goToCreatUserInvitationLink();
      return;
    }
    setQueryValue({ [MODAL_ID_PARAMS]: "true" });
  };

  return (
    <TuleButton
      label="Envoyer une invitation de création de compte"
      onClick={onClick}
      color={{
        text: "white",
        background: "#042536",
        border: "#3684A650",
      }}
    />
  );
}
